import React, { useState } from "react";

import { ROUTES } from "./Route";
import Login from "../Account/Login";
import BatchesManagementScreen from "./BatchesManagementScreen";

export default function BatchesManagement() {
  const [page, setPage] = useState(ROUTES.TRANING_MANAGEMENT);

  switch (page) {
    case ROUTES.TRANING_MANAGEMENT:
      return <BatchesManagementScreen setPage={setPage} />;
    default:
      return <Login />;
  }
}
